/* 🤖 this file was generated by svg-to-ts */
export const waytrTable = {
    name: 'table',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M42.05,8.05H6.05C2.74,8.05,.05,10.74,.05,14.05s2.69,6,6,6h14v2c0,1.1,.9,2,2,2v12H12.05c-1.1,0-2,.9-2,2s.9,2,2,2h24c1.1,0,2-.9,2-2s-.9-2-2-2h-10v-12c1.1,0,2-.9,2-2v-2h14c3.31,0,6-2.69,6-6s-2.69-6-6-6Z"/></svg>`,
};
